module.exports = __webpack_public_path__ + "static/media/11NEPAD4.f77b0496.jpg";